export default {"src":"/_next/static/media/mongodb.47f680af.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};